import { ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { AIPEmailBuilderComponent } from "@wlocalhost/ngx-email-builder";

import { EmailBodyComponent } from "../email-body/email-body.component";
import { TemplateListComponent } from "../template-list/template-list.component";
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from "src/app/shared/services/storage.service";
import { ToastrService } from "ngx-toastr";
import { CommonModelPopUpComponent } from '../../../../../src/app/components/common-model-pop-up/common-model-pop-up.component';
import { PopUpTitles } from "src/app/shared/model/enum";
import { TemplateService } from "../../../../ngx-email-builder/src/lib/services/template.service";
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: "tail-email-builder",
  templateUrl: "./tail-email-builder.component.html",
  styleUrls: ["./tail-email-builder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TailEmailBuilderComponent extends AIPEmailBuilderComponent {
  @ViewChild(EmailBodyComponent) emailBodyComponent:EmailBodyComponent | undefined;
  @ViewChild(TemplateListComponent) templateListComponent:TemplateListComponent | undefined;
  closedPreviewClick :boolean = false;
  previewClick :boolean = false;
  newTemplate:boolean = false;
  enumPopUpTitles = PopUpTitles;
  previewClicked = false;
  constructor(
    public modalService: NgbModal,
    templateService: TemplateService,
    storageService: StorageService,
    toastrService: ToastrService
  ) {
    super(templateService, storageService, toastrService);
  }
ngAfterViewInit() {
}
ngOnInit(): void {
}
  printContent() {
    const iframe = document.getElementById('iframePreview') as HTMLIFrameElement;
    const iframeWindow = iframe.contentWindow;
    const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
    if (iframeDocument) {
      const classWidthMap: { [key: string]: string } = {
        'mj-column-per-25': '25%',
        'mj-column-per-50': '50%',
        'mj-column-per-33': '33%',
        'mj-column-per-17': '17%',
        'mj-column-per-20': '20%',
      };
      Object.entries(classWidthMap).forEach(([className, width]) => {
        const elements = iframeDocument.querySelectorAll(`.${className}`);
        elements.forEach((element) => {
          const htmlElement = element as HTMLElement;
          htmlElement.style.width = width;
          htmlElement.style.maxWidth = width;
        });
      });
    }
    if (iframeWindow) {
        iframeWindow.focus();   
        iframeWindow.print(); 
        this.changePreviewDevice('desktop')
    }
  }
  iframeWidthSet(){
    const iframe = document.getElementById('iframePreview') as HTMLIFrameElement;
    const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
    if (iframeDocument) {
      const classWidthMap: { [key: string]: string } = {
        'mj-column-per-25': '100%',
        'mj-column-per-50': '100%',
        'mj-column-per-33': '100%',
        'mj-column-per-17': '100%',
        'mj-column-per-20': '100%',
      };
      Object.entries(classWidthMap).forEach(([className, width]) => {
        const elements = iframeDocument.querySelectorAll(`.${className}`);
        elements.forEach((element) => {
          const htmlElement = element as HTMLElement;
          htmlElement.style.width = width;
          htmlElement.style.maxWidth = width;
        });
      });
    }
    

  }
  openDeleteModal(event:any,label:any) {
      const modalOption: NgbModalOptions = {
        centered: true,
        backdrop: "static",
        keyboard: false,
        windowClass: "deletePop",
      };
      const modalRef = this.modalService.open(CommonModelPopUpComponent, modalOption);
      modalRef.componentInstance.title = this.enumPopUpTitles.DISCARD;
      modalRef.result.then((result) => {
        if (result.confirm == true) {
          label === 'new' ? this.back() : this.discard(event);
        }
      });
    }

  discard(event:any){
    this.closedPreviewClick = false;
    if(this.emailBodyComponent){
      this.emailBodyComponent.templateshow = false;
      this.emailBodyComponent.value.general.background = {color: "#f1f1f1"}
      this.emailBodyComponent.value.general.name = '';
      this.emailBodyComponent.showTemplateList(event)
    }
  }
  closedPreview(){
    this.closedPreviewClick = true;
    this.previewClick = true;
  }
  onpreviewClick() {
    this.previewClicked = true;
  }
  check() {
      return (
        !!this.emailBodyComponent &&
        this.emailBodyComponent.backButtonshow === false &&
        this.emailBodyComponent.templateshow === false &&
        this.emailBodyComponent.value?.structures?.length > 0 
      );
  }
  back(){
    this.closedPreviewClick = false;
    if(this.emailBodyComponent){
      this.emailBodyComponent.backButtonshow = false;
      this.emailBodyComponent.templateshow = false;
      this.emailBodyComponent.value.general.name = '';
      this.emailBodyComponent.value.general.padding.top = 16;
      this.emailBodyComponent.templateshow = false;
      this.emailBodyComponent.value.general.background = {color: "#f1f1f1"}
      this.emailBodyComponent.backNavigation(this.emailBodyComponent.value.structures);
    }
  }

getIframeHtml(): string {
    const iframe = document.getElementById('iframePreview') as HTMLIFrameElement;
    if (iframe && iframe.contentDocument) {
      const html = iframe.contentDocument.body.innerHTML;
      console.log('Iframe HTML content:', html);
      return html;
    } else {
      console.error('Iframe not loaded or cross-origin issue.');
      return '';
    }
  }
  exportPdfFromIframe1() {
    const html = this.getIframeHtml();
    if (!html) return;
    const container = document.createElement('div');
    container.innerHTML = html;
    document.body.appendChild(container);

    const options = {
      margin: 0.5,
      filename: 'email.pdf',
      image: { type: '.jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().from(container).set(options).save().then(() => {
      document.body.removeChild(container);
    });
  }
async exportPdfFromIframe(previewDevice:any) {
  const iframe = document.getElementById('iframePreview') as HTMLIFrameElement;

  if (!iframe || !iframe.contentDocument) {
    console.error('Iframe not loaded or cross-origin issue.');
    return;
  }
  let html = iframe.contentDocument.body.innerHTML;
   html = html.replace(/<!--[\s\S]*?-->/g, '').trim();
  console.log('Raw iframe HTML:', html);
 // html = this.applyColumnWidths(html);
  html = await this.convertImagesToBase64(html);
  const container = document.createElement('div');
  container.innerHTML = html;
  document.body.appendChild(container);

  const options = {
    margin: 0.5,
    filename: 'email.pdf',
    image: { type: 'jpeg', quality: 0.98 },
   html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
  };

  await html2pdf().from(container).set(options).save();
  document.body.removeChild(container);
}

// ✅ Apply widths directly to HTML string
applyColumnWidths(html: string): string {
  const container = document.createElement('div');
  container.innerHTML = html;

  const classWidthMap: { [key: string]: string } = {
    'mj-column-per-25': '20%',
    'mj-column-per-50': '50%',
    'mj-column-per-33': '33%',
    'mj-column-per-17': '17%',
    'mj-column-per-20': '20%',
  };

  Object.entries(classWidthMap).forEach(([className, width]) => {
    const elements = container.querySelectorAll(`.${className}`);
    elements.forEach((element) => {
      const htmlElement = element as HTMLElement;
      htmlElement.style.width = width;
      htmlElement.style.maxWidth = width;
      htmlElement.classList.add(`${className}-applied`);
    });
  });

  return container.innerHTML;
}
async convertImagesToBase64(html: string): Promise<string> {
  const container = document.createElement('div');
  container.innerHTML = html;

  const images = container.querySelectorAll('img');

  const promises = Array.from(images).map((img: HTMLImageElement) => {
    return new Promise<void>((resolve) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.src = img.src;

      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(image, 0, 0);
        img.src = canvas.toDataURL('image/png');
        console.log(img.src);
        resolve();
      };

      image.onerror = () => {
        console.warn('Image failed to load, skipping:', img.src);
        resolve();
      };
    });
  });

  await Promise.all(promises);
  return container.innerHTML;
}
async emailSend(){
  const iframe = document.getElementById('iframePreview') as HTMLIFrameElement;
  if (!iframe || !iframe.contentDocument) {
    console.error('Iframe not loaded or cross-origin issue.');
    return;
  }

  // This is not completely matches with preview 
  let html = iframe.contentDocument.body.innerHTML;
  html = html.replace(/<!--[\s\S]*?-->/g, '').trim();
  html = await this.convertImagesToBase64(html);
   const escapedHtml = html
    .replace(/\\/g, "\\\\")   // escape backslashes
    .replace(/"/g, '\\"')     // escape double quotes
    .replace(/\n/g, "");
   console.log('Raw iframe HTML:', escapedHtml);


  // with whole html directly send to email and matches the preview
  // let html = iframe?.contentDocument?.documentElement?.outerHTML
  // console.log('Raw iframe HTML:', html);
}
}
